import { type ErrorFilter } from '@funnellab/shared/src/errorHandling/errorFilter';
import type * as Sentry from '@sentry/react';

interface EventArgument {
  type?: string;
  [key: string]: unknown;
}

export const metaWebViewFilter: ErrorFilter = (
  event: Sentry.ErrorEvent,
): boolean => {
  const msg = event.exception?.values?.[0]?.value || event.message || '';
  const browserName =
    typeof event.contexts?.browser?.name === 'string'
      ? event.contexts.browser.name
      : '';
  const ua =
    typeof navigator !== 'undefined'
      ? navigator.userAgent
      : event.request?.headers?.['User-Agent'] || '';
  const isMetaWebView =
    /Instagram/i.test(browserName) ||
    /Instagram/i.test(ua) ||
    /Facebook/i.test(browserName) ||
    /Facebook/i.test(ua);

  const extraData = event.extra as
    | { arguments?: EventArgument[] }
    | undefined
    | null;
  const args = extraData?.arguments;
  const isBeforeUnload =
    Array.isArray(args) && args[0]?.type === 'beforeunload';

  const isJavaObjectGoneError = /Java object is gone/i.test(msg);

  return isMetaWebView && isBeforeUnload && isJavaObjectGoneError;
};
